import { useTranslation } from 'react-i18next'

import { AVATAR_HEIGHT_24 } from '../../../../Avatar'
import { EntityProfileHeaderInfoItemBase } from '../../../../Entity'
import { UserListItem } from '../../../../ListItem'
import { getRentalPortalApplicantIdentityLabel } from '../../../../RentalPortalApplicant'
import Text from '../../../../Text'
import { toViewingProfileApplicantValue } from '../../RentalPortalViewingProfile.utils'
import { QA_NAME_VIEWING_PROFILE_INFO_APPLICANT } from '../RentalPortalViewingProfileHeaderInfoItems.constants'
import { getIsViewingProfileApplicantMasked } from '../RentalPortalViewingProfileHeaderInfoItems.utils'
import { ViewingApplicantsInfoValue } from '../ViewingApplicantsInfoValue'

import LockIcon from '../../../../../icons/lock.svg'

function ViewingProfileApplicantItem({
  applicant,
  applicants,
  className,
  contentWrapperClassName,
  hasApplicantList,
  isClickable,
  itemClassName,
  titleClassName,
  onClickApplicant,
  onClickApplicantItem,
}) {
  const { t } = useTranslation()

  const applicantLabel = applicant
    ? getRentalPortalApplicantIdentityLabel({ applicant, t })
    : null

  return (
    <EntityProfileHeaderInfoItemBase
      actions={null}
      canEdit={false}
      className={className}
      contentWrapperClassName={contentWrapperClassName}
      title={
        hasApplicantList
          ? 'RentalPortal.ViewingApplicantsWidgetTitleKey'
          : 'RentalPortal.ViewingApplicantColumnKey'
      }
      titleClassName={titleClassName}
    >
      {hasApplicantList ? (
        <ViewingApplicantsInfoValue
          applicants={applicants}
          onClickApplicant={onClickApplicantItem}
        />
      ) : applicantLabel ? (
        <UserListItem
          AdditionalInfo={null}
          Icon={getIsViewingProfileApplicantMasked(applicant) ? LockIcon : null}
          avatarSize={AVATAR_HEIGHT_24}
          blocked={!isClickable}
          className={itemClassName}
          textQaName={QA_NAME_VIEWING_PROFILE_INFO_APPLICANT}
          tooltipAdditionalText={
            isClickable ? t('Common.ClickToOpenProfileKey') : null
          }
          value={toViewingProfileApplicantValue({
            applicant,
            label: applicantLabel,
          })}
          onClick={onClickApplicant}
        />
      ) : (
        <Text disabled isSecondary>
          {t('Select.NoDataKey')}
        </Text>
      )}
    </EntityProfileHeaderInfoItemBase>
  )
}

export default ViewingProfileApplicantItem
